import { defineMessages } from 'react-intl';

export default defineMessages({
    condominiumUsedAs: {
        id: 'tfpa.propertyDetails.views.messages.CondominiumUsedas',
        defaultMessage: 'Condominium Used as'
    },
    dwellingUsedAs: {
        id: 'tfpa.propertyDetails.views.messages.DwellingUsedas',
        defaultMessage: 'Dwelling Used as'
    },
    homeUsedAs: {
        id: 'tfpa.propertyDetails.views.messages.HomeUsedas',
        defaultMessage: 'Home Used as'
    },
    condominiumOccupancy: {
        id: 'tfpa.propertyDetails.views.messages.condominiumOccupancy',
        defaultMessage: 'Condominium Occupancy'
    },
    dwellingOccupancy: {
        id: 'tfpa.propertyDetails.views.messages.dwellingOccupancy',
        defaultMessage: 'Dwelling Occupancy'
    },
    homeis: {
        id: 'tfpa.propertyDetails.views.messages.homeis',
        defaultMessage: 'Home is'
    },
    condoForSale: {
        id: 'tfpa.propertyDetails.views.messages.Is the condominium for sale?',
        defaultMessage: 'Is the condominium for sale?'
    },
    dwellingForSale: {
        id: 'tfpa.propertyDetails.views.messages.dwellingForSale',
        defaultMessage: 'Is the dwelling for sale?'
    },
    condoRenov: {
        id: 'tfpa.propertyDetails.views.messages.condoRenov',
        defaultMessage: 'Is the condominium undergoing renovation or reconstruction?'
    },
    dwellingRenov: {
        id: 'tfpa.propertyDetails.views.messages.dwellingRenov',
        defaultMessage: 'Is the dwelling undergoing renovation or reconstruction?'
    },
    dwellingFirePlace: {
        id: 'tfpa.propertyDetails.views.messages.dwellingFirePlace',
        defaultMessage: 'Does the dwelling have a Fireplace?'
    },
    Fireplace: {
        id: 'tfpa.propertyDetails.views.messages.Fireplace',
        defaultMessage: 'Fireplace'
    },
    dwellingWoodStove: {
        id: 'tfpa.propertyDetails.views.messages.dwellingWoodStove',
        defaultMessage: 'Does the dwelling have a Wood Stove?'
    },
    woodStove: {
        id: 'tfpa.propertyDetails.views.messages.woodStove',
        defaultMessage: 'Wood Stove'
    },
    atleastOneDog: {
        id: 'tfpa.propertyDetails.views.messages.atleastOneDog',
        defaultMessage: 'Add at least one dog or exotic pet.'
    },
    yearMessage: {
        id: 'tfpa.propertyDetails.views.messages.yearMessage',
        defaultMessage: 'Year built cannot be greater than current year.'
    },
    yearMessageGreater: {
        id: 'tfpa.propertyDetails.views.messages.yearMessageGreater',
        defaultMessage: 'Year built must be greater than 1799.'
    }
});